import Component_LoneBox_811c025d66bc9712f5981a7d6c937fb2 from "../../../../content/guides/react-with-declarative-babylonjs/LoneBox";
import Devtool_LoneBox_811c025d66bc9712f5981a7d6c937fb2 from "!!@devtool/loader!../../../../content/guides/react-with-declarative-babylonjs/LoneBox";
import Component_BasicScene_811c025d66bc9712f5981a7d6c937fb2 from "../../../../content/guides/react-with-declarative-babylonjs/BasicScene";
import Devtool_BasicScene_811c025d66bc9712f5981a7d6c937fb2 from "!!@devtool/loader!../../../../content/guides/react-with-declarative-babylonjs/BasicScene";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_LoneBox_811c025d66bc9712f5981a7d6c937fb2,
  Devtool_LoneBox_811c025d66bc9712f5981a7d6c937fb2,
  Component_BasicScene_811c025d66bc9712f5981a7d6c937fb2,
  Devtool_BasicScene_811c025d66bc9712f5981a7d6c937fb2,
  DevTool,
  React
};